import { render } from "./AccountMenu.vue?vue&type=template&id=60a8c3b6"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__